// extracted by mini-css-extract-plugin
module.exports = {"keyTitle":"networksimulation_keyTitle__r28Br","divider":"networksimulation_divider__PUopO","content":"networksimulation_content__g2Q4x","button":"networksimulation_button__o2B_V"};